export const SPRECHEN_TASKS = [
  {
    "id": "sprechen-teil1",
    "teil": 1,
    "title": "Teil 1 — Kurzer Vortrag",
    "instruction": "Sie nehmen an einem Kurs teil und halten dort einen kurzen Vortrag. Wählen Sie ein Thema (Thema 1 oder 2) aus. Ihre Gesprächspartnerin/Ihr Gesprächspartner hört zu und stellt Ihnen anschließend Fragen. Strukturieren Sie Ihren Vortrag mit einer Einleitung, einem Hauptteil und einem Schluss. Sprechen Sie circa 4 Minuten.",
    "prepMinutes": 15,
    "speakMinutes": 4,
    "topics": [
      {
        "id": "topic1",
        "title": "Thema 1: Finanzierung des Studiums",
        "prompt": "Beschreiben Sie mehrere Alternativen.",
        "bulletPoints": [
          "Beschreiben Sie mehrere Alternativen.",
          "Nennen Sie Vor- und Nachteile und bewerten Sie diese.",
          "Beschreiben Sie eine Möglichkeit genauer."
        ]
      },
      {
        "id": "topic2",
        "title": "Thema 2: Gesund leben",
        "prompt": "Beschreiben Sie mehrere Bereiche (z. B. Bewegung).",
        "bulletPoints": [
          "Beschreiben Sie mehrere Bereiche (z. B. Bewegung).",
          "Beschreiben Sie einen Bereich genauer.",
          "Nennen Sie Vor- und Nachteile und bewerten Sie diese."
        ]
      }
    ],
    "evaluationCriteria": [
      "Vortrag mit Einleitung, Hauptteil und Schluss",
      "Alle Aufgabenpunkte behandelt",
      "Angemessener Wortschatz B2",
      "Verständliche Grammatik",
      "Flüssig und frei sprechen (nicht ablesen)"
    ]
  },
  {
    "id": "sprechen-teil2",
    "teil": 2,
    "title": "Teil 2 — Diskussion",
    "instruction": "Sie sind Teilnehmende eines Debattierclubs und diskutieren über die Frage: Sollen Studierende ihre Professoren beurteilen? Tauschen Sie Ihren Standpunkt und Ihre Argumente aus. Reagieren Sie auf die Argumente Ihrer Gesprächspartnerin/Ihres Gesprächspartners. Fassen Sie am Ende zusammen: Sind Sie dafür oder dagegen?",
    "speakMinutes": 5,
    "discussionTopic": "Sollen Studierende ihre Professoren beurteilen?",
    "discussionHints": [
      "Motivation nimmt zu/ab?",
      "Unterricht wird besser/schlechter?",
      "Fairness ist gegeben?",
      "Beurteilung bleibt anonym?"
    ],
    "scenarios": [
      {
        "id": "disk1",
        "title": "Sollen Studierende ihre Professoren beurteilen?",
        "situation": "Sie sind Teilnehmende eines Debattierclubs. Tauschen Sie Ihren Standpunkt und Ihre Argumente aus. Reagieren Sie auf die Argumente Ihres Partners/Ihrer Partnerin. Fassen Sie am Ende zusammen: Sind Sie dafür oder dagegen?",
        "roleA": {
          "label": "Position A — Pro Beurteilung",
          "arguments": [
            "Professoren werden motivierter",
            "Unterricht wird verbessert",
            "Studierende haben eine Stimme"
          ]
        },
        "roleB": {
          "label": "Position B — Contra Beurteilung",
          "arguments": [
            "Beurteilungen sind oft unfair",
            "Professoren passen Noten an",
            "Anonymität wird nicht garantiert"
          ]
        }
      }
    ],
    "evaluationCriteria": [
      "Standpunkt klar dargelegt",
      "Auf Argumente des Partners reagiert",
      "Höflich zugestimmt oder widersprochen",
      "Am Ende zusammengefasst (dafür/dagegen)"
    ]
  }
];
export const REDEMITTEL = {
  "meinung": [
    "Meiner Meinung nach …",
    "Ich bin der Ansicht, dass …",
    "Aus meiner Sicht …",
    "Ich finde, dass …"
  ],
  "argumente": [
    "Einerseits …, andererseits …",
    "Ein wichtiger Grund dafür ist, dass …",
    "Außerdem sollte man bedenken, dass …",
    "Allerdings muss man auch sagen, dass …"
  ],
  "zustimmung": [
    "Da stimme ich Ihnen zu.",
    "Das sehe ich genauso.",
    "Dem kann ich mich anschließen."
  ],
  "ablehnung": [
    "Da bin ich anderer Meinung.",
    "Dem kann ich nicht zustimmen, weil …",
    "Ich sehe das anders, denn …"
  ],
  "diskussion": [
    "Was halten Sie davon, wenn …?",
    "Haben Sie auch die Erfahrung gemacht, dass …?",
    "Könnten Sie das näher erklären?",
    "Lassen Sie mich ein Beispiel geben."
  ],
  "praesentation": [
    "Ich möchte heute über … sprechen.",
    "Zuerst erkläre ich …, danach …",
    "Zusammenfassend kann man sagen, dass …",
    "Gibt es dazu Fragen?"
  ]
};
